import { render, staticRenderFns } from "./back-to-homepage.vue?vue&type=template&id=5fff84c0&scoped=true"
import script from "./back-to-homepage.vue?vue&type=script&lang=js"
export * from "./back-to-homepage.vue?vue&type=script&lang=js"
import style0 from "./back-to-homepage.vue?vue&type=style&index=0&id=5fff84c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fff84c0",
  null
  
)

export default component.exports